import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteHandlerService {

  private _embeddedStyle: boolean = false;

  readonly rotas: {} = {
    importarNota: {
      routeKey: 'importar-nota',
      route: 'issqn/nota-fiscal/importar'
    },
    iss: {
      routeKey: 'iss',
      route: 'issqn/nota-fiscal/iss',
      params: ['cuc', 'id', 'tipoIss']
    },
    lancamentoNota: {
      routeKey: 'lancamento-nota',
      route: 'issqn/nota-fiscal/lancamento-nota',
      params: ['cuc', 'id', 'tipoIss', 'rota', 'PHPSESSID']
    },
    relatorioNota: {
      routeKey: 'relatorio-nota',
      route: 'issqn/nota-fiscal/relatorios',
      params: ['cuc', 'id', 'tipoIss', 'rota', 'PHPSESSID']
    }
  };

  constructor(private router: Router) { }

  navegar(params: any) {
    console.log(params)
    for (const r in this.rotas) {
      if(this.rotas[r].routeKey == params.rota) {
        this.embeddedStyle = true;
        let url: string = this.rotas[r].route;
        let queryParams: any = {}
        if(this.rotas[r].params && this.rotas[r].params.length) {
          this.rotas[r].params.forEach((p: string) => {
            if(params[p]){
              queryParams[p] = params[p];
            }
          });
        }

        this.router.navigate([url], {queryParams});
        return;
      }
    }
    this.embeddedStyle = false;
  }

  set embeddedStyle(embeddedStyle: boolean) {
    this._embeddedStyle = embeddedStyle;
  }

  get embeddedStyle() {
    return this._embeddedStyle;
  }
}
